import { extractColumnDisplayPreferences } from "@/lib/extract-columns-preferences";
import { DetailsDisplayMode, PaginationMode, SearchViewDisplayMode, GridColumnsPreset } from "@/user-preferences/enums";
import type { ColumnDisplayPreferenceSeed } from "@/lib/extract-columns-preferences";

export const createFacultyYearDefaultUserPreferences = (columns: ColumnDisplayPreferenceSeed[]) => {

    return {
        availableDisplayModes: [SearchViewDisplayMode.TREE],
        detailsDisplayMode: DetailsDisplayMode.PANEL,
        table: {
            fontSize: 14,
            defaultItemsPerPage: 50,
            displayItemsPerPageSelector: true,
            paginationMode: PaginationMode.PAGED,
            verticalPadding: 12,
            zebraLines: false,
            showVerticalLines: false,
            showHorizontalLines: true,
            wrapText: false,
            columns: extractColumnDisplayPreferences(columns),
        },
        grid: {
            masonryStyle: false,
            availableGridColumns: [
                GridColumnsPreset.AUTO_200,
                GridColumnsPreset.AUTO_250,
                GridColumnsPreset.AUTO_300,
                GridColumnsPreset.AUTO_400,
            ],
            gridColumns: GridColumnsPreset.AUTO_250,
        },
        tree: {
            fontSize: 14,
            defaultItemsPerPage: 50,
            displayItemsPerPageSelector: true,
            paginationMode: PaginationMode.PAGED,
            showTreeLines: true,
            indentationPerLevel: 24,
            defaultExpandedDepth: 999, // Expand all elements by default
            enableDragAndDrop: true,
        },
        viewCustom: {},
    };
};

import { faculty_year_column_display_seeds } from "./column-display-seeds";

export const facultyYearDefaultUserPreferences = createFacultyYearDefaultUserPreferences(faculty_year_column_display_seeds);
